<template>
  <div class="l-container content-block">
    <UiPriceChart
      :page-data="props.pageData"
      :is-collapsed="false"
      class="l-description-grid"
    />
  </div>
  <div class="l-container content-block">
    <div v-if="props.seoData" id="description-model" class="l-description-grid">
      <PageModelDescriptionModel :seo-data="props.seoData" />
    </div>
    <div v-if="accessories.length > 0" class="l-description-grid">
      <ModelSimilar
        :similar="accessories"
        title="Аксессуары"
        type="accessories"
        :show-more-button="false"
        :page-data="pageData"
        :model-id="props.pageData.model.id"
        :changed-page="props.pageData.changedPage"
        full-width-mobile
        @change-data="(e) => emit('change-data', e)"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
const emit = defineEmits(['change-data']);
const accessories = computed(() => props.pageData?.model?.accessories || []);
const props = defineProps({
  pageData: {
    type: Object as () => any,
    required: true,
  },
  seoData: {
    type: Object as () => any,
    required: true,
  },
});
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 16px;
  @include xl-block {
    margin-bottom: 24px;
  }
}
</style>
